import { render, staticRenderFns } from "./CheckButton.vue?vue&type=template&id=66fa1466&scoped=true"
import script from "./CheckButton.vue?vue&type=script&lang=js"
export * from "./CheckButton.vue?vue&type=script&lang=js"
import style0 from "./CheckButton.vue?vue&type=style&index=0&id=66fa1466&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fa1466",
  null
  
)

export default component.exports